module.exports = __webpack_public_path__ + "img/arrow-up-right-circle-fill.686e6c0d.svg";